module.exports = __webpack_public_path__ + "img/public/SiteIcons/transmissionIcon.svg?e3d0e7df";